var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6299 2H2.62988C2.0776 2 1.62988 2.44772 1.62988 3V9C1.62988 9.55228 2.0776 10 2.62988 10H10.6299C11.1822 10 11.6299 9.55228 11.6299 9V3C11.6299 2.44772 11.1822 2 10.6299 2Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6299 3.5L7.14488 6.35C6.99052 6.44671 6.81204 6.49801 6.62988 6.49801C6.44772 6.49801 6.26925 6.44671 6.11488 6.35L1.62988 3.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/SVG (2).8bb24c04276376282eefd8f6eaa9b71a.svg";
export { ForwardRef as ReactComponent };